import { render, staticRenderFns } from "./questionInfo.vue?vue&type=template&id=10503756&scoped=true&"
import script from "./questionInfo.vue?vue&type=script&lang=js&"
export * from "./questionInfo.vue?vue&type=script&lang=js&"
import style0 from "./questionInfo.vue?vue&type=style&index=0&id=10503756&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10503756",
  null
  
)

export default component.exports